import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { useState } from "react";

import CrmInsurance from "./CrmInsurance";

import { selectCurrentUser } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import InsuranceMisAnalytics from "./InsuranceMisAnalytics";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const InsuranceParent = () => {

  const [cardName, setCardValue] = useState("Insurance");
 
  const handleActiveCard = (cardName) => {
    setCardValue(cardName);
  };
 
  return (
    <>
    
        <div className="radio-inputs" style={{ marginTop: "-10px" }}>
         
          <label className="radio">
            <div onClick={() => handleActiveCard("Insurance")}>
              <input
                type="radio"
                name="radio"
                checked={cardName === "Insurance" ? true : false}
              />
              <span
                className={`name ${
                  cardName === "Insurance" ? "fw-bold text-primary" : "fw-bold"
                }`}
              >
                Insurance
              </span>
            </div>
          </label>
           <label className="radio">
            <div onClick={() => handleActiveCard("analytics")}>
              <input
                type="radio"
                name="radio"
                checked={cardName === "analytics" ? true : false}
              />
              <span
                className={`name ${
                  cardName === "analytics" ? "fw-bold text-primary" : "fw-bold"
                }`}
              >
                Analytics
              </span>
            </div>
          </label>
        </div>
    
      {cardName === "Insurance" ? (
              <CrmInsurance />

      ) : (
        <InsuranceMisAnalytics />
      )}
    </>
  );
};

export default InsuranceParent;
